module.exports = __webpack_public_path__ + "img/fog.b961da5e.png";